import { render, staticRenderFns } from "./Curtains.vue?vue&type=template&id=73ba35eb&scoped=true&"
import script from "./Curtains.vue?vue&type=script&lang=js&"
export * from "./Curtains.vue?vue&type=script&lang=js&"
import style0 from "./Curtains.vue?vue&type=style&index=0&id=73ba35eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba35eb",
  null
  
)

export default component.exports